import * as actionTypes from './actionTypes';
import initialState from 'store/initialState'; // eslint-disable-line

export default function(state = initialState.navigation, action) {
  switch (action.type) {
    case actionTypes.SET_NAVIGATION:
      return action.payload;
    case actionTypes.SET_CURRENT_PATH:
      return { ...state, currentPath: action.payload };
    case actionTypes.SET_PREVIOUS_PATH:
      return { ...state, previousPath: action.payload };
    case actionTypes.SET_IS_NAVIGATING:
      return { ...state, isNavigating: action.payload };
    case actionTypes.SET_DIRECTION:
      return { ...state, direction: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/navigation/reducer.js